export const getTimeZone = () => {
  const computedTimeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;

  return computedTimeZone.toString();
};
